// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.NoData_no-data-container__FmxkJ {
  margin: auto;
  margin-top: 0rem;
  width: 100%;
  height: 35rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(128, 128, 128, 0.61);
}
.NoData_no-data-container__FmxkJ h2 {
  color: #333333;
  margin-top: 7.5rem;
  font-size: 1.8rem;
  word-spacing: 0.1rem;
  margin-bottom: 5rem;
}
.NoData_no-data-container__FmxkJ p {
  color: #333333;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  text-align: center;
}

.NoData_try-this-box__iAnWE {
  width: 25rem;
  display: flex;
  flex-direction: column;
}

.NoData_no-data-load-button__47BF3:hover {
  background: #286090;
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/utils/_base.scss","webpack://./src/components/Misc/NoData.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AClCA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACSJ;ADPI;EACI,YAAA;EACA,aAAA;ACSR;ADNI;EACI,gBAAA;ACQR;;ADHA,uBAAA;AAQA,mBAAA;ACtBA;EACE,YAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2CAAA;AAsBF;AApBE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAsBJ;AAnBE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAqBJ;;AAjBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AAoBF;;AAjBA;EACE,mBF9BsB;AEkDxB","sourcesContent":[null,null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.no-data-container {\n  margin: auto;\n  margin-top: 0rem;\n  width: 100%;\n  height: 35rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid rgba(128, 128, 128, 0.61);\n}\n.no-data-container h2 {\n  color: #333333;\n  margin-top: 7.5rem;\n  font-size: 1.8rem;\n  word-spacing: 0.1rem;\n  margin-bottom: 5rem;\n}\n.no-data-container p {\n  color: #333333;\n  margin-bottom: 0.5rem;\n  font-size: 1.25rem;\n  text-align: center;\n}\n\n.try-this-box {\n  width: 25rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.no-data-load-button:hover {\n  background: #286090;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-data-container": `NoData_no-data-container__FmxkJ`,
	"try-this-box": `NoData_try-this-box__iAnWE`,
	"no-data-load-button": `NoData_no-data-load-button__47BF3`
};
export default ___CSS_LOADER_EXPORT___;
